import { render } from "./KycPage.vue?vue&type=template&id=485ca6ae&ts=true"
import script from "./KycPage.vue?vue&type=script&lang=ts"
export * from "./KycPage.vue?vue&type=script&lang=ts"

import "./KycPage.vue?vue&type=style&index=0&id=485ca6ae&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__